module.exports = __webpack_public_path__ + "img/2_3_redeem_type_2.e680ca65.gif";